import React from 'react'
import { Link } from 'react-router-dom'

const Store = () => {
  return (
    <div className='store-full'>
        <div className='store-box'>
            <Link to="/chaashni-experience-center-delhi">
            <div className='store-overlaytext'>
                <div className='store-bigtext'>The Experience Center <small>Naraina, New Delhi</small></div>
                <div className='store-link'><span>Explore</span></div>
            </div>
            <img src='/images/the-experience-center.jpg' alt='The Experience Center' />
            </Link>
        </div>
        <div className='store-box'>
            <Link to="/book-appointment">
            <div className='store-overlaytext'>
                <div className='store-normaltext'>Meet us in-store <br /> or virtually <br /> to explore the <br /> magic of CHAASHNI</div>
                <div className='store-link'><span>Book an Appointment </span></div>
            </div>
                <img src='/images/book-an-appointment.jpg' alt='Book an Appointment' />
            </Link>
        </div>
    </div>
  )
}

export default Store
